import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type Theme = "light" | "dark" | "system";

interface SettingsState {
  isOnline: boolean;
  theme: Theme;
  language: string;
  notifications: boolean;
  rolesCount: number;
}

const initialState: SettingsState = {
  isOnline: navigator.onLine,
  theme: "system",
  language: "en",
  notifications: true,
  rolesCount: 0,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,

  reducers: {
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
    },
    setTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    toggleNotifications: (state) => {
      state.notifications = !state.notifications;
    },
    setRolesCount: (state, action: PayloadAction<number>) => {
      state.rolesCount = action.payload;
    },
  },
});

export const { setOnlineStatus, setTheme, setLanguage, toggleNotifications, setRolesCount } = settingsSlice.actions;
// selectors
export const settingSelector = (state: any) => state.setting as SettingsState;

export default settingsSlice.reducer;
